<div class="screen">

  <!-- ── Protocole recommandé ── -->
  <div class="section">
    <p class="section-title">{{ 'mobileSimulator.modeDegrade.protocolTitle' | translate }}</p>
    <p class="section-sub">{{ 'mobileSimulator.modeDegrade.protocolSub' | translate }}</p>
    <div class="step-list">
      <div class="step-item">
        <span class="step-num">1</span>
        <span>{{ 'mobileSimulator.modeDegrade.step1' | translate }}</span>
      </div>
      <div class="step-item">
        <span class="step-num">2</span>
        <span>{{ 'mobileSimulator.modeDegrade.step2' | translate }}</span>
      </div>
      <div class="step-item">
        <span class="step-num">3</span>
        <span>{{ 'mobileSimulator.modeDegrade.step3' | translate }}</span>
      </div>
      <div class="step-item">
        <span class="step-num">4</span>
        <span>{{ 'mobileSimulator.modeDegrade.step4' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- ── Actions recommandées ── -->
  <div class="section">
    <p class="section-title">{{ 'mobileSimulator.modeDegrade.actionsTitle' | translate }}</p>

    <p class="section-sub">{{ 'mobileSimulator.modeDegrade.ifAccueilTension' | translate }}</p>
    <div class="bullet-list">
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.accueilBullet1' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.accueilBullet2' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.accueilBullet3' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.accueilBullet4' | translate }}</div>
    </div>

    <p class="section-sub section-sub--mt">{{ 'mobileSimulator.modeDegrade.ifPrelevementTension' | translate }}</p>
    <div class="bullet-list">
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.prelevementBullet1' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.prelevementBullet2' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.prelevementBullet3' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.prelevementBullet4' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.prelevementBullet5' | translate }}</div>
    </div>
  </div>

  <!-- ── Coordination multi-site ── -->
  <div class="section">
    <p class="section-title">{{ 'mobileSimulator.modeDegrade.coordinationTitle' | translate }}</p>
    <p class="section-text">{{ 'mobileSimulator.modeDegrade.coordinationText' | translate }}</p>
    <div class="bullet-list">
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.coordinationBullet1' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.coordinationBullet2' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.coordinationBullet3' | translate }}</div>
    </div>
  </div>

  <!-- ── Pratiques terrain ── -->
  <div class="section">
    <p class="section-title">{{ 'mobileSimulator.modeDegrade.fieldPracticesTitle' | translate }}</p>
    <div class="warning-banner">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
      <p>{{ 'mobileSimulator.modeDegrade.warningBanner' | translate }}</p>
    </div>

    <p class="section-sub">{{ 'mobileSimulator.modeDegrade.simplifiedFileTitle' | translate }}</p>
    <p class="section-text">{{ 'mobileSimulator.modeDegrade.simplifiedFileText' | translate }}</p>
    <div class="bullet-list">
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.simplifiedBullet1' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.simplifiedBullet2' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.simplifiedBullet3' | translate }}</div>
    </div>
    <div class="vigilance-box">
      <p class="vigilance-title">{{ 'mobileSimulator.modeDegrade.vigilancePointsTitle' | translate }}</p>
      <div class="bullet-list bullet-list--warn">
        <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.vigilanceBulletA1' | translate }}</div>
        <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.vigilanceBulletA2' | translate }}</div>
        <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.vigilanceBulletA3' | translate }}</div>
      </div>
    </div>

    <p class="section-sub section-sub--mt">{{ 'mobileSimulator.modeDegrade.acceleratedPathTitle' | translate }}</p>
    <p class="section-text">{{ 'mobileSimulator.modeDegrade.acceleratedPathText' | translate }}</p>
    <div class="bullet-list">
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.acceleratedBullet1' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.acceleratedBullet2' | translate }}</div>
      <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.acceleratedBullet3' | translate }}</div>
    </div>
    <div class="vigilance-box">
      <p class="vigilance-title">{{ 'mobileSimulator.modeDegrade.vigilancePointsTitle' | translate }}</p>
      <div class="bullet-list bullet-list--warn">
        <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.vigilanceBulletB1' | translate }}</div>
        <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.vigilanceBulletB2' | translate }}</div>
        <div class="bullet-item">{{ 'mobileSimulator.modeDegrade.vigilanceBulletB3' | translate }}</div>
      </div>
    </div>
  </div>

  <!-- ── Retour nominal ── -->
  <div class="section">
    <p class="section-title">{{ 'mobileSimulator.modeDegrade.returnTitle' | translate }}</p>
    <p class="section-text">{{ 'mobileSimulator.modeDegrade.returnText' | translate }}</p>
  </div>

  <!-- ── Info importante ── -->
  <div class="info-banner">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
    </svg>
    <p>{{ 'mobileSimulator.modeDegrade.infoBanner' | translate }}</p>
  </div>

  <!-- ── CTA ── -->
  <button class="activate-btn" [attr.data-tension]="tensionKey()" (click)="activate()">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
    </svg>
    {{ 'mobileSimulator.modeDegrade.activateButton' | translate }}
  </button>

</div>
